/**
 * @file addMutationHandler
 * @author yuzong(yuzong@tencent.com)
 */
import { MutationHandler } from '../lib/MutationHandler';
/**
 * 添加元素变化事件监控
 *
 * @param callback 回调函数
 * @param options 监控选项
 */

export var addMutationHandler = MutationHandler.addMutationHandler;